export default "__VITE_ASSET__BD_Pw2oE__"